import React, { useEffect, useState } from "react";
import { Col, Container, Row, Card, Button } from "react-bootstrap";
import MultiCarousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import "./Blog.css";
import {
  AiOutlineGitlab,
  AiOutlineGlobal,
  AiOutlineMeh,
  AiOutlineRadarChart,
  AiOutlineTeam,
} from "react-icons/ai";
import { SiOracle } from "react-icons/si";
import DedicatedResources from "../../assets/img/home-it/Dedicated-Resources.png";
import ItConsultancyServices from "../../assets/img/home-it/IT-Consultancy-Services.png";
import ItOutsource from "../../assets/img/home-it/IT-Outsource.png";
import Oracleconsulting from "../../assets/img/home-it/Oracle-consulting.png";
import SoftwareDevelopement from "../../assets/img/home-it/Software-Developement.png";
import { FiChevronUp } from "react-icons/fi";
import { MdDoubleArrow } from "react-icons/md";
import { FaAmericanSignLanguageInterpreting } from "react-icons/fa";
import reasons from "../../assets/img/Blog-section/5-Reasons-Why-You-Need-a-Digital-Marketing-Company.jpg";
import challenges from "../../assets/img/Blog-section/Challenges-in-Digital-Marketing-and-How-to-Overcome-Them.jpg";
import future from "../../assets/img/Blog-section/The-Future-of-E-commerce-and-Digital-Marketing-Navigating-the-Next-Decade.jpg";
import importance from "../../assets/img/Blog-section/The-Importance-of-User-Generated-Content-in-Digital-Marketing.jpg";
import build from "../../assets/img/Blog-section/how-to-build-a-strong-online-brand-presence.jpg";
import inflencer from "../../assets/img/Blog-section/influencer-section.png";
import emailmarketing from "../../assets/img/Blog-section/email-marketing.jpg";
import ai from "../../assets/img/Blog-page/ai-section.jpg";
import impact from "../../assets/img/Blog-page/The-Impact-of-Video-Marketing-Elevating-Engagement-and-Driving-Results-section.png";
import successful from "../../assets/img/Blog-page/Most-Successful-Digital-Marketing-Campaigns-What-We-Can-Learn.jpg";
import exploring from "../../assets/img/Blog-section/Exploring-the-Power-section.png";
import local from "../../assets/img/Blog-section/Local-SEO-section.png";
import BrandMemorable from "../../assets/img/Blog-section/Brand-Memorable-section.png";
import googleIo from "../../assets/img/Blog-section/Google-IO-2026-How-AI-is-Transforming-Search-SEO-and-Digital-Marketing.jpg";
import howTo from "../../assets/img/Blog-section/How-to-Get-Your-Brand-Mentioned-by-ChatGPT,-Gemini,-and-Google-AI-Search.jpg";
import trnasforming from "../../assets/img/Blog-section/Transforming-Digital-Marketing-in-2026-How-AI-Is-Shaping-the-Future.jpg";
import digitalMarketing from "../../assets/img/Blog-section/What-is-AI-powered-digital-marketing-and-how-can-it-help.jpg";
import AiContent from "../../assets/img/Blog-section/Top-8-AI-Content-Creation-Tools-in-2026-Free-and-Paid-breadcrumb.jpg";
import googleBusiness from "../../assets/img/Blog-section/google-business-profile-ai-messaging.jpg";

function InformationTechnology() {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="information-technology-section  blog-section pb-0 pt-5 bg-white">
      <Container fluid className="position-relative px-lg-4">
        <Row className="align-items-start justify-content-center">
          <Col lg={10}>
            <h2 className="main-title main-title-3 wow animate__animated animate__fadeInUp text-center">
              Blogs
            </h2>
            <p className="main-text fst-italic wow animate__animated animate__fadeInUp text-center m-1">
              Global Insights: Trends Shaping Tomorrow
            </p>
            <p className="main-text wow animate__animated animate__fadeInUp text-center mb-3">
              Keep up with the latest trends and ideas from different industries
              across the globe. Our blog shares easy-to-understand updates on
              new technologies, fashion, and changing customer choices. Whether
              you’re a business owner or just curious about what’s new, this is
              the place to learn and stay informed with Global Trendz.
            </p>
          </Col>
          <MultiCarousel
            swipeable={true}
            draggable={true}
            showDots={false}
            responsive={responsive}
            infinite={false}>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/google-business-profile-ai-messaging">
                  <img
                    src={googleBusiness}
                    className="img-fluid service-visual"
                    alt="google-business-profile-ai-messaging"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>03-11-2026</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/google-business-profile-ai-messaging">
                      Google Business Profile Update (2026): AI-Powered
                      Messaging
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    What if your Google Business Profile could answer customer
                    queries even when you're busy or unavailable? Your Google
                    Business Profile is getting smarter! <br /> Google is
                    introducing AI-powered messaging capabilities to Google
                    Business Profiles, making it easier for customers to
                    interact with businesses directly through Google Search and
                    Maps.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/google-business-profile-ai-messaging"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/top-10-ai-content-creation-tools-in-2026">
                  <img
                    src={AiContent}
                    className="img-fluid service-visual"
                    alt="What Makes a Brand Memorable in 2025?
"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>19-09-2026</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/top-10-ai-content-creation-tools-in-2026">
                      Top 10 AI Content Creation Tools in 2026 (Free & Paid)
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Struggling to create content that actually ranks on Google
                    in 2026? You’re not alone. With increasing competition and
                    ever-changing algorithms, writing high-quality,
                    SEO-optimized content consistently can feel overwhelming. AI
                    content creation tools will have become essential for
                    producing high-quality, SEO-optimized content quickly and
                    efficiently.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/top-10-ai-content-creation-tools-in-2026"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/top-8-ai-tools-for-google-and-meta-ads-in-2026">
                  <img
                    src={digitalMarketing}
                    className="img-fluid service-visual"
                    alt="What Makes a Brand Memorable in 2025?
"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>18-09-2026</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/top-8-ai-tools-for-google-and-meta-ads-in-2026-track-and-optimize-your-ads">
                      Top 8 AI Tools for Google and Meta Ads in 2026: Track and
                      Optimize your Ads
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    In today's competitive digital marketing landscape,
                    businesses invest heavily in online advertising to attract
                    customers and increase sales. Platforms like Google Ads,
                    Meta Ads, LinkedIn Ads, Microsoft Advertising, and Amazon
                    Ads provide businesses with opportunities to reach millions
                    of users. However, managing multiple campaigns, tracking
                    performance, and making timely adjustments can be
                    challenging without the right tools.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/top-8-ai-tools-for-google-and-meta-ads-in-2026-track-and-optimize-your-ads"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/what-is-ai-powered-digital-marketing-and-how-can-it-help">
                  <img
                    src={digitalMarketing}
                    className="img-fluid service-visual"
                    alt="What Makes a Brand Memorable in 2025?
"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>17-09-2026</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/what-is-ai-powered-digital-marketing-and-how-can-it-help">
                      What Is AI-Powered Digital Marketing and How Can It Help?
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Artificial Intelligence (AI) is transforming the way
                    businesses connect with customers. AI-powered digital
                    marketing leverages machine learning, automation, and data
                    analysis to create smarter, faster, and more effective
                    marketing campaigns. Instead of relying on guesswork, AI
                    helps businesses make informed decisions based on customer
                    behavior and real-time insights.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/what-is-ai-powered-digital-marketing-and-how-can-it-help"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/transforming-digital-marketing-in-2026-how-ai-is-shaping-the-future">
                  <img
                    src={trnasforming}
                    className="img-fluid service-visual"
                    alt="What Makes a Brand Memorable in 2025?
"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>29-07-2026</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/transforming-digital-marketing-in-2026-how-ai-is-shaping-the-future">
                      Transforming Digital Marketing in 2026: How AI Is Shaping
                      the Future
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Digital marketing has undergone significant evolution over
                    the past few years, and in 2026, Artificial Intelligence
                    (AI) is a key driver behind this transformation. Businesses
                    are no longer using AI only to automate repetitive tasks.
                    Today, AI enables marketers to understand customer behavior,
                    create personalized experiences, enhance search visibility,
                    and make faster data-driven decisions.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/transforming-digital-marketing-in-2026-how-ai-is-shaping-the-future"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/how-to-get-your-brand-mentioned-by-chatgpt-gemini-and-google-ai-search">
                  <img
                    src={howTo}
                    className="img-fluid service-visual"
                    alt="What Makes a Brand Memorable in 2025?
"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>28-07-2026</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/how-to-get-your-brand-mentioned-by-chatgpt-gemini-and-google-ai-search">
                      How to Get Your Brand Mentioned by ChatGPT, Gemini, and
                      Google AI Search
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Search is evolving faster than ever before. Consumers are no
                    longer relying solely on traditional search engines to find
                    products, services, and businesses. Instead, they are
                    increasingly turning to AI-powered platforms such as
                    ChatGPT, Gemini, and Google AI Search to get direct answers,
                    recommendations, and insights. AI tools are becoming the
                    first place people search for businesses, services, and
                    expert recommendations. This creates a major opportunity,
                    but also a challenge. If your brand isn't visible to AI
                    systems, you could miss potential customers when they're
                    actively looking for solutions.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/how-to-get-your-brand-mentioned-by-chatgpt-gemini-and-google-ai-search"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/google-io-2026-how-ai-is-transforming-search-seo-and-digital-marketing">
                  <img
                    src={googleIo}
                    className="img-fluid service-visual"
                    alt="What Makes a Brand Memorable in 2025?
"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>27-07-2026</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/google-io-2026-how-ai-is-transforming-search-seo-and-digital-marketing">
                      Google I/O 2026: How AI is Transforming Search, SEO, and
                      Digital Marketing
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Google I/O 2026 made one thing clear: search is no longer
                    only about keywords. It is now fueled by artificial
                    intelligence (AI), user intent, and personalized
                    experiences. Google's AI-powered search is transforming how
                    users discover information, and companies fight for online
                    prominence.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/google-io-2026-how-ai-is-transforming-search-seo-and-digital-marketing"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/what-makes-a-brand-memorable-in-2025">
                  <img
                    src={BrandMemorable}
                    className="img-fluid service-visual"
                    alt="What Makes a Brand Memorable in 2025?
  "
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>04-02-2025</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/what-makes-a-brand-memorable-in-2025">
                      What Makes a Brand Memorable in 2025?
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    In a world of constant digital noise and evolving consumer
                    expectations, standing out as a brand has never been more
                    crucial. As we move into 2025, successful brands are those
                    that forge deep connections with their audience, innovate
                    continuously, and maintain authenticity. Here are the key
                    factors that make a brand memorable in 2025.{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/what-makes-a-brand-memorable-in-2025"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/local-seo-tips-to-dominate-your-niche-in-2025">
                  <img
                    src={local}
                    className="img-fluid service-visual"
                    alt="Local SEO Tips to Dominate Your Niche in 2025
"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>03-01-2025</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/local-seo-tips-to-dominate-your-niche-in-2025">
                      Local SEO Tips to Dominate Your Niche in 2025
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Local SEO has become a game-changer for businesses aiming to
                    attract customers in their immediate vicinity. With evolving
                    algorithms and the growing reliance on mobile search,
                    dominating your niche in 2025 requires a proactive,
                    strategic approach. Here are actionable tips to help your
                    business stay ahead of the curve.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/local-seo-tips-to-dominate-your-niche-in-2025"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/exploring-the-power-of-Voice-Search-and-Its-Impact-on-digital-marketing">
                  <img
                    src={exploring}
                    className="img-fluid service-visual"
                    alt="Exploring the Power of Voice Search and Its Impact on Digital Marketing"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>19-12-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/exploring-the-power-of-Voice-Search-and-Its-Impact-on-digital-marketing">
                      Exploring the Power of Voice Search and Its Impact on
                      Digital Marketing
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    In today's fast-paced world, convenience is everything. We
                    want things to be faster, easier, and more hands-free. This
                    is where voice search comes in. Whether you're asking Siri
                    for the weather, telling Alexa to play music, or using
                    Google Assistant to find something, voice search is becoming
                    a huge part of our daily lives.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/exploring-the-power-of-Voice-Search-and-Its-Impact-on-digital-marketing"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/2024's-most-successful-digital-marketing-campaigns">
                  <img
                    src={successful}
                    className="img-fluid service-visual"
                    alt="Most Successful Digital Marketing Campaigns: What We Can Learn
"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>10-12-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a
                      href="/2024's-most-successful-digital-marketing-campaigns"
                      style={{ textTransform: "inherit" }}>
                      2024's Most Successful Digital Marketing Campaigns: What
                      We Can Learn
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Digital marketing in 2024 saw some truly remarkable
                    campaigns that not only caught the attention of audiences
                    but also delivered outstanding results. By taking a closer
                    look at these campaigns, we can learn valuable lessons on
                    how to approach our marketing strategies in the future.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/2024's-most-successful-digital-marketing-campaigns"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/the-impact-of-video-marketing-elevating-engagement-and-driving-results">
                  <img
                    src={impact}
                    className="img-fluid service-visual"
                    alt="How to Build a Strong Online Brand Presence"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>30-11-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/the-impact-of-video-marketing-elevating-engagement-and-driving-results">
                      The Impact of Video Marketing: Elevating Engagement and
                      Driving Results
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Video marketing has become one of the most powerful tools
                    for businesses looking to engage with their audience, boost
                    brand awareness, and drive conversions. In an increasingly
                    digital world, consumers are seeking dynamic, visual content
                    that grabs their attention and delivers information quickly
                    and effectively. From social media platforms to websites,
                    videos are proving to be an essential component of any
                    successful marketing strategy.
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/the-impact-of-video-marketing-elevating-engagement-and-driving-results"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/the-role-of-ai-and-automation-in-digital-marketing">
                  <img
                    src={ai}
                    className="img-fluid service-visual"
                    alt="How to Build a Strong Online Brand Presence"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>16-11-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/the-role-of-ai-and-automation-in-digital-marketing">
                      The Role of AI and Automation in Digital Marketing
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Artificial intelligence (AI) and automation have transformed
                    the digital marketing landscape, enabling businesses to
                    engage customers more effectively, optimize campaigns, and
                    drive better results with less manual effort.{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/the-role-of-ai-and-automation-in-digital-marketing"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="technology-card">
                            <div className="technology-card-inner">
                                <a href="/the-role-of-ai-and-automation-in-digital-marketing">
                                    <img
                                        src={ai}
                                        className="img-fluid service-visual"
                                        alt="How to Build a Strong Online Brand Presence"
                                    />
                                </a>

                                <div className="blog-content-card">
                                    <svg stroke="currentColor" fill="none" stroke-width="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path></svg>
                                    <span>16-11-2024</span>
                                    <h3 className="how-it-works-card__title text-start heading-content">
                                        <a href="/the-role-of-ai-and-automation-in-digital-marketing">The Role of AI and Automation in Digital Marketing



                                        </a>
                                    </h3>
                                    <p className="how-it-works-card__text blog-content">
                                        Artificial intelligence (AI) and automation have transformed the digital marketing landscape, enabling businesses to engage customers more effectively, optimize campaigns, and drive better results with less manual effort. </p>
                                    <div className="read-more-button">
                                        <a href="/the-role-of-ai-and-automation-in-digital-marketing" class="btn btn-primary talk mt-5px">Read More</a>

                                    </div>
                                </div>

                            </div>
                        </div> */}
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/best-strategies-for-successful-email-marketing-campaign">
                  <img
                    src={emailmarketing}
                    className="img-fluid service-visual"
                    alt="How to Build a Strong Online Brand Presence"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>09-11-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/best-strategies-for-successful-email-marketing-campaign">
                      Best Strategies for Successful Email Marketing Campaign
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Email marketing remains one of the most powerful tools for
                    businesses to connect with their audience, build
                    relationships, and drive conversions. With the right
                    strategy, email marketing can deliver a high return on
                    investment (ROI), outperforming many other digital marketing
                    channels.{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/best-strategies-for-successful-email-marketing-campaign"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/influencer-marketing-how-to-choose-the-right-partners">
                  <img
                    src={inflencer}
                    className="img-fluid service-visual"
                    alt="How to Build a Strong Online Brand Presence"
                  />
                </a>

                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>26-10-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/influencer-marketing-how-to-choose-the-right-partners">
                      Influencer Marketing: How to Choose the Right Partners
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    In today’s digital landscape, influencer marketing has
                    emerged as a powerful tool for brands to reach targeted
                    audiences in a more authentic and engaging way. By
                    partnering with influencers (individuals with a dedicated
                    following on social media or other platforms), brands can
                    tap into their influence and credibility to promote products
                    or services.{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/influencer-marketing-how-to-choose-the-right-partners"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/5-reasons-why-you-need-a-digital-marketing-company">
                  <img
                    src={reasons}
                    className="img-fluid service-visual"
                    alt="5 Reasons Why You Need a Digital Marketing Company"
                  />
                </a>
                {/* <p className="fst-italic mb-0">Providing Robust Solutions</p> */}
                <div className="blog-content-card">
                  <div className="ps-0">
                    <svg
                      stroke="currentColor"
                      fill="none"
                      stroke-width="1.5"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                    </svg>
                    <span>24-09-2024</span>
                  </div>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/5-reasons-why-you-need-a-digital-marketing-company">
                      5 Reasons Why You Need a Digital Marketing Company
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    In the current digital era, a company's ability to prosper
                    and grow depends on its online presence. It might be
                    difficult to differentiate yourself from the competition and
                    successfully reach your target audience given the abundance
                    of businesses in every area.{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/5-reasons-why-you-need-a-digital-marketing-company"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
                {/* <a
                                    href={`${"software development".replace(/ /g, "-")}`}
                                    className="service-read-more"
                                >
                                    <MdDoubleArrow />
                                </a> */}
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/challenges-in-digital-marketing-and-how-to-overcome-them">
                  <img
                    src={challenges}
                    className="img-fluid service-visual"
                    alt="Challenges in Digital Marketing and How to Overcome Them"
                  />
                </a>
                {/* <p className="fst-italic mb-0">Revamp Your IT Environment</p> */}
                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>24-09-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/challenges-in-digital-marketing-and-how-to-overcome-them">
                      Challenges in Digital Marketing and How to Overcome Them
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    Digital marketing has become an essential component of any
                    business strategy, offering unparalleled opportunities to
                    reach and engage with target audiences.{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/challenges-in-digital-marketing-and-how-to-overcome-them"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
                {/* <a
                                    href={`${"it consulting".replace(/ /g, "-")}`}
                                    className="service-read-more"
                                >
                                    <MdDoubleArrow />
                                </a> */}
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/the-future-of-e-commerce-and-digital-marketing:navigating-the-next-decade">
                  <img
                    src={future}
                    className="img-fluid service-visual"
                    alt="The Future of E-commerce and Digital Marketing: Navigating the Next Decade"
                  />
                </a>
                {/* <p className="fst-italic mb-0">
                                    Elevating Your Business Performance
                                </p> */}
                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>24-09-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/the-future-of-e-commerce-and-digital-marketing:navigating-the-next-decade">
                      The Future of E-commerce and Digital Marketing: Navigating
                      the Next Decade
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    As the world becomes increasingly digital, the future of
                    e-commerce and digital marketing is poised to evolve at an
                    unprecedented pace. The rise of new technologies, changing
                    consumer behaviors, and the ongoing global shift towards
                    online shopping are reshaping how businesses operate and
                    interact with their customers. This article explores key
                    trends and innovations that will define the future of
                    e-commerce and digital marketing and how businesses can
                    adapt to stay ahead in this rapidly changing landscape.{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/the-future-of-e-commerce-and-digital-marketing:navigating-the-next-decade"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
                {/* <a
                                    href={`${"dedicated resource".replace(/ /g, "-")}`}
                                    className="service-read-more"
                                >
                                    <MdDoubleArrow />
                                </a> */}
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/the-importance-of-user-generated-content-in-digital-marketing">
                  <img
                    src={importance}
                    className="img-fluid service-visual"
                    alt="The Importance of User-Generated Content in Digital Marketing"
                  />
                </a>
                {/* <p className="fst-italic mb-0">Enhancing Your IT Solutions</p> */}
                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>24-09-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/the-importance-of-user-generated-content-in-digital-marketing">
                      The Importance of User-Generated Content in Digital
                      Marketing
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    In today's digital landscape, user-generated content (UGC)
                    has become a powerful asset for businesses aiming to build
                    trust, foster engagement, and drive conversions.{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/the-importance-of-user-generated-content-in-digital-marketing"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
                {/* <a
                                    href={`${"it outsource".replace(/ /g, "-")}`}
                                    className="service-read-more"
                                >
                                    <MdDoubleArrow />
                                </a> */}
              </div>
            </div>
            <div className="technology-card">
              <div className="technology-card-inner">
                <a href="/how-to-build-a-strong-online-brand-presence">
                  <img
                    src={build}
                    className="img-fluid service-visual"
                    alt="How to Build a Strong Online Brand Presence"
                  />
                </a>
                {/* <p className="fst-italic mb-0">
                                    Optimizing Oracle Capabilities
                                </p> */}
                <div className="blog-content-card">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path>
                  </svg>
                  <span>24-09-2024</span>
                  <h3 className="how-it-works-card__title text-start heading-content">
                    <a href="/how-to-build-a-strong-online-brand-presence">
                      How to Build a Strong Online Brand Presence
                    </a>
                  </h3>
                  <p className="how-it-works-card__text blog-content">
                    In today's digital world, having a strong online brand
                    presence is essential for any business. Your online presence
                    is how people find and connect with your brand, so it's
                    important to make a great impression{" "}
                  </p>
                  <div className="read-more-button">
                    <a
                      href="/how-to-build-a-strong-online-brand-presence"
                      class="btn btn-primary talk mt-5px">
                      Read More
                    </a>
                  </div>
                </div>
                {/* <a
                                    href={`${"oracle consulting".replace(/ /g, "-")}`}
                                    className="service-read-more"
                                >
                                    <MdDoubleArrow />
                                </a> */}
              </div>
            </div>

            {/* <div className="technology-card">
                            <div className="technology-card-inner">
                                <a href="/the-role-of-ai-and-automation-in-digital-marketing">
                                    <img
                                        src={build}
                                        className="img-fluid service-visual"
                                        alt="How to Build a Strong Online Brand Presence"
                                    />
                                </a>

                                <div className="blog-content-card">
                                    <svg stroke="currentColor" fill="none" stroke-width="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path></svg>
                                    <span>26-10-2024</span>
                                    <h3 className="how-it-works-card__title text-start heading-content">
                                        <a href="/the-role-of-ai-and-automation-in-digital-marketing">The Role of AI and Automation in Digital Marketing


                                        </a>
                                    </h3>
                                    <p className="how-it-works-card__text blog-content">
                                        Artificial intelligence (AI) and automation have transformed the digital marketing landscape, enabling businesses to engage customers more effectively, optimize campaigns, and drive better results with less manual effort. By leveraging AI and automation, companies can streamline tasks, personalize marketing efforts, and  </p>
                                    <div className="read-more-button">
                                        <a href="/the-role-of-ai-and-automation-in-digital-marketing" class="btn btn-primary talk mt-5px">Read More</a>

                                    </div>
                                </div>

                            </div>
                        </div> */}
            {/* <div className="technology-card">
                            <div className="technology-card-inner">
                                <a href="/the-impact-of-video-marketing-elevating-engagement-and-driving-results">
                                    <img
                                        src={build}
                                        className="img-fluid service-visual"
                                        alt="How to Build a Strong Online Brand Presence"
                                    />
                                </a>

                                <div className="blog-content-card">
                                    <svg stroke="currentColor" fill="none" stroke-width="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"></path></svg>
                                    <span>26-10-2024</span>
                                    <h3 className="how-it-works-card__title text-start heading-content">
                                        <a href="/the-impact-of-video-marketing-elevating-engagement-and-driving-results">The Impact of Video Marketing: Elevating Engagement and Driving Results



                                        </a>
                                    </h3>
                                    <p className="how-it-works-card__text blog-content">
                                        Video marketing has become one of the most powerful tools for businesses looking to engage with their audience, boost brand awareness, and drive conversions. In an increasingly digital world, consumers are seeking dynamic, visual content that grabs their attention and delivers information quickly and effectively.  </p>
                                    <div className="read-more-button">
                                        <a href="/the-impact-of-video-marketing-elevating-engagement-and-driving-results" class="btn btn-primary talk mt-5px">Read More</a>

                                    </div>
                                </div>

                            </div>
                        </div> */}
          </MultiCarousel>
        </Row>
      </Container>
    </section>
  );
}

export default InformationTechnology;
